import React from 'react';
import { Typography, Box, Divider } from '@mui/material';

/**
 * ページレイアウトの共通コンポーネント
 * @param {Object} props - コンポーネントのプロパティ
 * @param {string} props.title - ページのタイトル
 * @param {string} props.margin - Boxのmargin
 * @param {React.ReactNode} props.children - レイアウト内に表示するコンテンツ
 */

const RegistarLayout = ({
  title,
  margin,
  marginTop,
  width, 
  children
}) => {
  return (
    <>
      <Box
      sx={{
        width: "1100px",
        padding: "20px",
        borderRadius: "10px",
        border: "2px solid #333",
        backgroundColor: "#fff",
        fontFamily: "Arial, sans-serif",
        margin,
        marginTop
      }}>
      <Typography variant="h2">{title}</Typography>
      <Divider sx={{ borderBottom: "2px solid #32c86b", marginTop: "10px", marginBottom: "30px"}} />
      {children}
      </Box>
    </>
  );
};

export default RegistarLayout;